import { useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../lib/i18n";
import { LEGAL_SLUGS } from "../lib/legal";

const COOKIE_KEY = "mm_cookie_notice";

export function LegalLinks({ className = "", testid = "legal-links" }) {
  const { t } = useLang();
  return (
    <p className={`text-center text-xs text-slate-400 ${className}`} data-testid={testid}>
      {LEGAL_SLUGS.map((s, i) => (
        <span key={s}>
          {i > 0 && <span className="mx-1.5">·</span>}
          <Link to={`/legal/${s}`} className="transition-colors hover:text-brand" data-testid={`${testid}-${s}`}>{t(`legal.${s}`)}</Link>
        </span>
      ))}
    </p>
  );
}

export function CookieNotice() {
  const { t } = useLang();
  const [show, setShow] = useState(() => !localStorage.getItem(COOKIE_KEY));
  if (!show) return null;
  const close = () => {
    localStorage.setItem(COOKIE_KEY, "1");
    setShow(false);
  };
  return (
    <div className="fixed inset-x-3 bottom-3 z-[60] mx-auto flex max-w-md items-center gap-3 rounded-2xl bg-navy/95 px-4 py-3 text-white shadow-[0_10px_30px_rgba(13,42,107,0.35)] backdrop-blur-md pb-safe"
      data-no-swipe data-testid="cookie-notice">
      <p className="flex-1 text-xs leading-snug text-white/90">
        {t("legal.cookieNotice")}{" "}
        <Link to="/legal/cookies" className="font-bold text-white underline underline-offset-2" data-testid="cookie-notice-more">{t("legal.moreInfo")}</Link>
      </p>
      <button onClick={close} className="shrink-0 rounded-full bg-white px-3.5 py-1.5 text-xs font-extrabold text-navy transition-transform active:scale-95" data-testid="cookie-notice-accept">
        {t("legal.gotIt")}
      </button>
    </div>
  );
}
